import api from '@/api/base'
import { strictExtend } from '@shared/utils/base/index.js'
import { ERR_CODE } from '@shared/utils/errCode/constant'

import { CacheSetOtherUserInfo } from '@/utils/cache'

const isDevOrTest = (process.env.STAGE === 'test' || process.env.NODE_ENV === 'development')

const defaultConfig = {
  baseURL: isDevOrTest ? 'http://pdfconvertweb.aix-test-k8s.iweikan.cn/' : 'https://office-pdfconv-srv.keniu.com/',
  requestDataFn: function (req) {
    const data = {
      common: {
        app_id: '15',
        platform: 'web',
        uid: window.app?.$store?.state?.pdf?.pdfUserInfo?.uid,
        token: window.app?.$store?.state?.pdf?.pdfUserInfo?.token
      }
    }
    req.data = Object.assign(data, req.data, {
      common: Object.assign(data.common, (req.data && req.data.common) || {})
    })
    return req
  },

  responseSuccessFn: function (res) {
    const data = res.data
    const respCommon = strictExtend({
      msg: '',
      ret: -1
    }, data.resp_common)

    delete data.resp_common

    if (respCommon.ret === ERR_CODE.AUTH_EXPIRED) {
      const _this = window.app
      _this.$toast('登录已过期', { duration: 4000 })
      _this.$store.dispatch('pdf/logout')

      _this.$store.commit('vuexUpdateUserInfo', {})
      CacheSetOtherUserInfo({})
      window.parent.postMessage({ type: 'logout' }, '*') // pdf地token一天多失效，local记录有效是一天，所以，过期一般意味着外部token失效
    }

    return {
      resp_common: respCommon,
      ret: respCommon.ret,
      data
    }
  }
}

api.add('fileConvert', defaultConfig, {
  // 请求转换：http://apix.kisops.com/project/879/interface/api/37821
  convert: { url: '/pdfwebbrowser/convert' },
  // 上报文件上传完成：http://apix.kisops.com/project/879/interface/api/37826
  reportUpload: { url: '/pdfwebbrowser/report_upload' },
  // 开始转换：http://apix.kisops.com/project/879/interface/api/37831
  startConvert: { url: '/pdfwebbrowser/start_convert' },
  // 获取转换进度，http://apix.kisops.com/project/879/interface/api/37836
  queryProgress: { url: '/pdfwebbrowser/query_progress' },

  // pdf 登录
  login: { url: '/user/login' },
  // pdf 登出
  logout: { url: '/user/logout' },
  // pdf 刷新用户,支付成功后调该接口
  refresh: { url: '/user/refresh' },

  // 转换记录，http://apix.kisops.com/project/879/interface/api/37841
  listConvert: { url: '/pdfwebbrowser/list_convert' },
  // 删除转换记录，http://apix.kisops.com/project/879/interface/api/38651
  delConvert: { url: '/pdfwebbrowser/del_convert' },
  // 获取用户信息，http://apix.kisops.com/project/879/interface/api/38766
  userInfo: { url: '/user/info' }
})

export default api
